/*eslint-disable */
const $ = window.jQuery = require('jquery');
import commonSocketRef from "@/videoNotificationSocket";
import toast from '@/services/toast';
import {bus} from '@/main';  
export default {
  name: 'recreating-pre-view-popup',
  components: {},
  props: ['appointmentId', 'recreatingPrescDATA'],
  data () {
    return {
      preCreationDone:true,
      prescriptionData:{
        drug:'',
        route:'',
        direction:'After Meals',
        frequency:[],
        duration:'',
        quantity:'',
        dose:'',
        strength:'',
        duration_unit:'Days',
        dose_unit:'Ml',
        strength_unit:'Mg',
        frequency_others:'',
        special_instruction:'',
      },
      prescriptionName:'',
      frequencyOthersKeyRequired:false,
      submitted:false,
      prescriptionDetailsData:[],
      preOfPateintId:'',
      preOfAppointmentId:'',
      preCreationSpclInstructionDone:false
    }
  },
  computed: {

  },
  mounted () {
    if(this.recreatingPrescDATA){
      this.preOfAppointmentId = this.appointmentId
      this.preOfPateintId = this.recreatingPrescDATA.patient_id
      this.prescriptionData.drug = this.recreatingPrescDATA.prescription_details[0].drug
      this.prescriptionData.route = this.recreatingPrescDATA.prescription_details[0].route
      this.prescriptionData.direction = this.recreatingPrescDATA.prescription_details[0].direction
      this.prescriptionData.frequency = this.recreatingPrescDATA.prescription_details[0].frequency
      this.prescriptionData.duration = this.recreatingPrescDATA.prescription_details[0].duration.split(' ')[0]
      this.prescriptionData.quantity = this.recreatingPrescDATA.prescription_details[0].quantity
      this.prescriptionData.dose = this.recreatingPrescDATA.prescription_details[0].dose.split(' ')[0]
      this.prescriptionData.strength = this.recreatingPrescDATA.prescription_details[0].strength.split(' ')[0]
      this.prescriptionData.strength_unit = this.recreatingPrescDATA.prescription_details[0].strength.split(' ')[1]
      this.prescriptionData.duration_unit = this.recreatingPrescDATA.prescription_details[0].duration.split(' ')[1]
      this.prescriptionData.dose_unit = this.recreatingPrescDATA.prescription_details[0].dose.split(' ')[1]
      this.prescriptionData.frequency_others = this.recreatingPrescDATA.prescription_details[0].drug
    }
  },
  methods: {
    frequencyOthersFun(){
      if(this.frequencyOthersKeyRequired == false){
        this.frequencyOthersKeyRequired = true
        this.prescriptionData.frequency = []
        this.prescriptionData.frequency_others = 'if required'
      }else{
        this.frequencyOthersKeyRequired = false
        this.prescriptionData.frequency_others = ''
      }
    },
    closePrescriptionPopupMethod(){
      bus.$emit('recreatingPrescDataPopupStateBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
    createPrescriptionBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var record = {}
          record.drug = this.prescriptionData.drug
          record.route = this.prescriptionData.route
          record.direction = this.prescriptionData.direction
          record.frequency = JSON.stringify(this.prescriptionData.frequency)
          record.quantity = this.prescriptionData.quantity
          record.duration = this.prescriptionData.duration + ' ' + this.prescriptionData.duration_unit  
          record.dose = this.prescriptionData.dose + ' ' + this.prescriptionData.dose_unit  
          record.strength = this.prescriptionData.strength + ' ' + this.prescriptionData.strength_unit 
          record.frequency_others = this.prescriptionData.frequency_others
          this.prescriptionDetailsData.push(record)
          this.submitted =  false
          setTimeout(() => {
            this.prescriptionData.drug = ''
            this.prescriptionData.route = ''
            this.prescriptionData.direction = 'After Meals'
            this.prescriptionData.frequency = []
            this.prescriptionData.duration = ''
            this.prescriptionData.quantity = ''
            this.prescriptionData.dose = ''
            this.prescriptionData.strength = ''
            this.prescriptionData.duration_unit = 'Days'
            this.prescriptionData.dose_unit = 'Ml'
            this.prescriptionData.strength_unit = 'Mg'
            this.prescriptionData.frequency_others = ''
            this.frequencyOthersKeyRequired = false
            this.$validator.reset()
          }, 400)
          return;
        }
      })
    },  
    submitPrescriptionBeforeSubmitMethod(){
      this.submitted =  true
      let data = {
        patient_id:this.preOfPateintId,
        appointment_id:this.preOfAppointmentId,
        prescription_details :this.prescriptionDetailsData
      }
      this.$store.dispatch('createPrescriptionOfPatientMethod', data)
        .then((res) => {  
          this.prescriptionData.prescriptionID = res.data.data.id
          let notificationPayload = { 
            type:'patient_prescription',
            data_id:this.prescriptionData.prescriptionID,
            message:'patient prescription has benn created'
          }
          this.$store.dispatch('postNotificationFunc', notificationPayload)
          this.submitted =  false
          this.preCreationDone = false
          this.preCreationSpclInstructionDone = true
          commonSocketRef.emit({
            message: `Prescription Data`,
            type: "patient_prescription",
            patient_id:this.preOfPateintId,
            appointment_id:this.preOfAppointmentId,
          });
          toast.success(res.data.msg);
        }).catch((err) => {
          this.submitted =  false
          toast.error(err.data.user_msg || err.data.msg);
        })
      return;
    }, 
    spclInstructionUpdateMethod(){
      if(this.prescriptionData.special_instruction){
        this.submitted =  true
        let data = {
          special_instruction : this.prescriptionData.special_instruction
        }
        this.$store.dispatch('updatePrescriptionDataOfPatientMethod', {data:{data:data,id:this.prescriptionData.prescriptionID}}).then((res) => {
          this.submitted =  false
          this.preCreationSpclInstructionDone = false
        })
      }else{
        this.preCreationSpclInstructionDone = false
      }
    },
  }
}